module.exports = __webpack_public_path__ + "static/media/wifi.43d9606f.svg";